// Ralph 24.10.2026: Fehlerakten (BUT-…) zeigen ihren genauen Stand statt des groben „In Arbeit“.
export const BUTLER_STATUS_META = {
  offen: { label: "Offen", color: "bg-blue-100 text-blue-800" },
  in_untersuchung: { label: "In Untersuchung", color: "bg-amber-100 text-amber-800" },
  reparatur_vorbereitet: { label: "Reparatur vorbereitet", color: "bg-amber-100 text-amber-800" },
  behoben: { label: "Behoben – bitte prüfen", color: "bg-violet-100 text-violet-800" },
  ueberprueft: { label: "Überprüft", color: "bg-teal-100 text-teal-800" },
  erledigt: { label: "Erledigt", color: "bg-emerald-100 text-emerald-800" },
  nicht_reproduzierbar: { label: "Nicht reproduzierbar", color: "bg-slate-100 text-slate-700" },
  verworfen: { label: "Verworfen", color: "bg-slate-100 text-slate-500" },
};
